/**
 * Helper to format date strings to include the weekday name.
 * e.g. "31-10-2026" -> "31-10-2026 (Saturday)"
 *      "01-11-2026" -> "01-11-2026 (Sunday)"
 */
export const formatConvocationDate = (val) => {
  if (!val || typeof val !== "string") {
    return val || "N/A";
  }

  const trimmed = val.trim();
  if (
    trimmed === "" ||
    trimmed === "NA" ||
    trimmed === "N/A" ||
    trimmed.toLowerCase() === "courier"
  ) {
    return trimmed || "N/A";
  }

  // Already contains a day name
  if (/sunday|monday|tuesday|wednesday|thursday|friday|saturday/i.test(trimmed)) {
    return trimmed;
  }

  // Matches DD-MM-YYYY or DD/MM/YYYY
  const ddmmyyyy = trimmed.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
  if (ddmmyyyy) {
    const day = parseInt(ddmmyyyy[1], 10);
    const month = parseInt(ddmmyyyy[2], 10) - 1;
    const year = parseInt(ddmmyyyy[3], 10);
    const dateObj = new Date(year, month, day);
    if (!isNaN(dateObj.getTime())) {
      const weekday = dateObj.toLocaleDateString("en-US", { weekday: "long" });
      return `${trimmed} (${weekday})`;
    }
  }

  // Matches YYYY-MM-DD
  const yyyymmdd = trimmed.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/);
  if (yyyymmdd) {
    const year = parseInt(yyyymmdd[1], 10);
    const month = parseInt(yyyymmdd[2], 10) - 1;
    const day = parseInt(yyyymmdd[3], 10);
    const dateObj = new Date(year, month, day);
    if (!isNaN(dateObj.getTime())) {
      const weekday = dateObj.toLocaleDateString("en-US", { weekday: "long" });
      return `${trimmed} (${weekday})`;
    }
  }

  return trimmed;
};
